import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    gap: 2,
    style: _normalizeStyle($options.getComputedStyle),
    class: "evolution-value"
  }, [_renderSlot(_ctx.$slots, "default", {
    color: $options.evolutionColor
  }, undefined, true)], 4);
}